import { Icon } from "../../../components/BaseComponents/Icon";

export const CancelIcon = (props) => (
	<Icon viewBox="0 0 24 24" fill="none" {...props}>
		<path
			xmlns="http://www.w3.org/2000/svg"
			stroke="currentColor"
			strokeWidth="2"
			d="M6.34 17.66A8 8 0 1 0 17.66 6.34M6.34 17.66A8 8 0 0 1 17.66 6.34M6.34 17.66 17.66 6.34"
		/>
	</Icon>
);
